export function canRrhh(user, permission) {
    const permissions = new Set(user?.permissions || []);
    return permissions.has(`access.${permission.split('.')[0]}`) && permissions.has(permission);
}
